import { Injectable, inject } from "@angular/core";
import { isNil } from "lodash";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { ApiClientService } from "~app/common/services/api-client.service";
import { VKVirkeskostnaderResponseDTO } from "../dto/virkeskostnader/virkeskostnader-dto";
import { Virkeskostnader } from "../models/virkeskostnader/virkeskostnader-models";

@Injectable({
    providedIn: "root"
})
export class VirkeskostnaderService {
    private readonly apiClientService = inject(ApiClientService);

    getVirkeskostnaderForKontrakt(kontraktId?: number): Observable<Virkeskostnader> {
        if (!isNil(kontraktId)) {
            return this.apiClientService.get<VKVirkeskostnaderResponseDTO>(`virkeskop2/kontrakt/${kontraktId}/virkeskostnader`)
                .pipe(map(dto => new Virkeskostnader(dto)));
        } else {
            return of({} as Virkeskostnader);
        }
    }
}
